<script>
import Cookies from 'js-cookie'
import { PLANBOOK_API_HOSTNAME, PBF_UAT_HOSTNAME } from 'common/utils/variables'
import { PLANBOOK_PAGE_MAP } from '@/config/assets'
import { COVER } from '../base/config'
import { bApp, APPID, isWeCom } from 'base/config'
import {
  getUrlParam,
  parseTime,
  getLocalStorage,
  setLocalStorage,
  buriedSubmit
} from 'common/js/common'
import { BottomSheets, Icon } from 'bxs-ui-vue'

import { APP_CHANNEL } from '@/common/utils/variables'
import { shareDirect } from '@/common/bridge'

const NG_TIME = 1000 * 60 * 60 * 24 * 7 // 1周
const supportExport = window.appBridge.checkAppFeature(
  'HANDLE_FILE_DOWNLOAD_AND_SHARE'
)

export default {
  name: 'PlanToExport',
  components: {
    [Icon.name]: Icon,
    [BottomSheets.name]: BottomSheets
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    miniprogram: {
      type: Boolean,
      default: false
    },
    isFamily: {
      type: Boolean,
      default: false
    },
    cardUuid: {
      type: String,
      default: ''
    },
    config: {
      type: Array,
      default () {
        return ['pdf', 'word', '表格', '思维导图']
      }
    }
  },
  data () {
    return {
      isShow: false,
      typeVal: 0,
      coverVal: 1,
      disabled: false
    }
  },
  computed: {
    typeOptions () {
      return supportExport ? this.config : ['图片', '思维导图']
    },
    coverOptions () {
      const { value, miniprogram, isFamily } = this
      if (isNaN(value) && value > 0) return []
      let list = COVER[value - 1]
      if (!Array.isArray(list)) return []
      return list.filter((item, index) => {
        // 隐藏
        // <图片>家庭计划书-第1、3个（去掉竖图、长图）
        // <文档>企微/小程序-前3个（去掉word）
        return (
          !item.hidden &&
          (isFamily && value == 2 ? index === 0 || index === 2 : true) &&
          ((isWeCom || miniprogram) && value === 1 ? index < 3 : true)
        )
      })
    }
  },
  watch: {
    value: {
      handler (value) {
        this.isShow = value !== 0
      },
      immediate: true
    },
    isShow (val) {
      if (val) {
        this.valueInit()
        buriedSubmit(this.value === 1 ? 'wendang' : 'tupian')
        return
      }
      this.$emit('input', 0)
    }
  },
  created () {
    this.localStorageKey = this.isFamily
      ? 'WeiyiStat_pbfm_export'
      : 'WeiyiStat_pb_export'
  },
  methods: {
    valueInit () {
      const { localStorageKey, value } = this
      if (!localStorageKey) return
      const exportVal = getLocalStorage(`${localStorageKey}_${value}`)
      if (!exportVal) return
      this.coverVal = exportVal
    },
    handleTypeChanges (index) {
      if (this.typeVal === index) return
      this.typeVal = index
      this.handleChanges(0)
    },
    handleChanges (index) {
      if (this.coverVal === index + 1) return
      this.coverVal = index + 1
    },
    handleDetermine () {
      const {
        RESULT_VERSION,
        value,
        miniprogram,
        cardUuid,
        isFamily,
        coverVal,
        localStorageKey,
        coverOptions
      } = this
      const uuid = isFamily ? getUrlParam('familyId') : getUrlParam('uuid')
      const theme = getUrlParam('theme')
      const coverId = getUrlParam('coverId')
      const appid = APPID || Cookies.get('appId')
      let url

      setLocalStorage(`${localStorageKey}_${value}`, coverVal, NG_TIME)
      // 导出文档
      if (value === 1) {
        const isWord = coverVal > 3
        const familyExportWordUrl = `${PLANBOOK_API_HOSTNAME}/planBook/export/family/export?word=true&fId=${uuid}&userAppId=${appid}&userStrId=${cardUuid}`
        const familyExportPdfUrl  = `${PLANBOOK_API_HOSTNAME}/planBook/export/family/export?pdf=true&fId=${uuid}&userAppId=${appid}&userStrId=${cardUuid}`
        const resultExportWordUrl = `${PLANBOOK_API_HOSTNAME}/planBook/pdfExport/pbResult?word=1&resultUuid=${uuid}`
        const resultExportPdfUrl  = `${PLANBOOK_API_HOSTNAME}/planBook/pdfExport/pbResult?resultUuid=${uuid}`
        if (isWord) {
          url = isFamily ? familyExportWordUrl : resultExportWordUrl
          buriedSubmit('word')
        } else {
          url = isFamily ? familyExportPdfUrl : resultExportPdfUrl
          if (coverVal) {
            url += `&coverType=${coverVal}`
          }
          buriedSubmit(['pdf_jianyue', 'pdf_shangwu', 'pdf_weiyi'][coverVal - 1])
        }
        if (isWeCom || miniprogram) {
          location.href = `${PLANBOOK_PAGE_MAP.pdfViewer}?file=${encodeURIComponent(url)}&title=${document.title}${parseTime(new Date(), '{h}-{i}-{s}')}`
          return
        }
       
        if ('NUOYA' === APP_CHANNEL) {
          shareDirect({
            shareUrl: url,
            type: isWord ? 3 : 2
          })
          return
        }

        if (!bApp) {
          location.href = url
          return
        }
        const fileParams = {
          url,
          title: `${document.title}${parseTime(new Date(), '{h}-{i}-{s}')}`,
          action: isWord ? 'downloadAndShare' : 'sharePdf'
        }
        console.log('导出文档：', fileParams)
        window.appBridge.handleFile(fileParams)
      }
      if (value === 2) {
        // 最后一个选项，认为是长图。
        const option = coverVal - 1 >= 0 && coverOptions[coverVal - 1]
        if (!option) {
          return
        }
        buriedSubmit(option.key)
        if (option.key === 'LongPic') {
          if (!appBridge || !appBridge.checkAppFeature('CAPTURE_WEB_CONTENT')) {
            return
          }
          this.$emit('screen-capture', async () => {
            try {
              const res = await appBridge.captureWebContent()
              return Promise.resolve(res.status)
            } catch (err) {
              console.log('err', err)
              return Promise.reject(err)
            }
          })
          return
        }
        url = `${PBF_UAT_HOSTNAME}/planBook/planBookResult/pages/planbkChartv2.html?nw=1&index=${option.index}&${isFamily ? 'familyId' : 'uuid'}=${uuid}&resultVersion=${RESULT_VERSION || ''}`
        if (coverId || coverId == 0) url += `&coverId=${coverId}`
        if (theme) url += `&theme=${theme}`
        location.href = url
      }
    }
  }
}
</script>
<template>
  <bxs-bottom-sheets
    v-model="isShow"
    class="pdf-bottom-sheets"
    :title="value === 1 ? '选择文档导出类型' : '选择图片导出类型'"
    height="middle"
    :use-b-scroll="false"
    :prevent-scroll-through="true"
  >
    <div class="export-wrapper">
      <ul class="export-cover-list">
        <li
          v-for="(item, index) in coverOptions"
          :key="index"
          data-stat-id="sc_mb"
          :data-stat-ep="JSON.stringify({
            type: item.key || index
          })"
          @click="handleChanges(index)"
        >
          <div class="img-wrapper">
            <div
              class="img-bg"
              :class="{ default: item.default || !item.image }"
            >
              <img v-if="item.image" :src="item.image" :alt="index">
            </div>
            <div class="my-radio-icon-wrap">
              <input
                v-model="coverVal"
                class="input"
                type="radio"
                name="cover"
                :value="index + 1"
              >
              <bxs-icon name="circle" />
              <bxs-icon name="circle-dot" />
              <span class="radio-text">{{ item.label }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div slot="footer" class="bottom-link">
      <a class="to-table-report" href="javascript:;" @click="handleDetermine">
        确定
      </a>
    </div>
  </bxs-bottom-sheets>
</template>
<style lang="postcss" scoped>
.export-wrapper {
  color: #333;
  font-size: 15px;
}

.export-title {
  padding: 21px 15px 0;
  font-size: 15px;
}

.export-type-list,
.export-cover-list {
  display: flex;
  flex-wrap: wrap;
}

.export-type-list {
  padding: 0 15px;

  & > li {
    flex-basis: 25%;
    padding-top: 15px;
  }
}

.export-cover-list {
  padding: 14px 3px 0;

  & > li {
    flex-basis: 33.3%;
    margin-bottom: 15px;
  }

  .img-wrapper {
    padding: 0 12px;

    .img-bg {
      position: relative;
      overflow: hidden;
      background-color: #d8d8d8;
      margin-bottom: 12px;
      border-radius: 6px;
      padding-bottom: 132%;
    }

    .default {
      img {
        visibility: hidden;
      }
    }

    img {
      z-index: 1;
      left: 0;
      top: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }
}

.my-radio-icon-wrap {
  display: block;
  text-align: left;

  .bx-icon-circle,
  .bx-icon-circle-dot {
    font-size: 18px;
    width: 18px;
    pointer-events: none;
    vertical-align: middle;
    color: #ccc;
  }

  .bx-icon-circle-dot {
    display: none;
  }

  .input {
    display: none;

    &:checked ~ .bx-icon-circle {
      display: none;
    }

    &:checked ~ .bx-icon-circle-dot {
      display: inline-block;
    }

    &[disabled='disabled'] ~ i {
      color: #ccc;
    }
  }

  .radio-text {
    margin-left: 4px;
    font-size: 12px;
    vertical-align: middle;
    pointer-events: none;
  }
}
</style>
